<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <section class="search">
            <div class="row">
              <div class="col-10 offset-1">
                <p class="text-center">請以關鍵字搜尋職業後選擇一種分類：</p>
                <form class="form">
                  <div class="input-group input-lg">
                    <div class="input">
                      <input
                        type="text"
                        maxlength="50"
                        name="keyword"
                        id="keyword"
                        class="form-control"
                        v-model="keyword"
                        placeholder="可輸入職業關鍵字搜尋"
                        @input="checkKeyword"
                        @blur="checkKeyword"
                      />
                    </div>
                    <button class="btn btn-primary btn-icon" @click.stop.prevent="findJob()">
                      <i class="icon-search i-24"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section>
          <section class="maintain mt-5">
            <div class="row data-row" v-if="!jobsLoading&&jobList.length>0">
              <div
                class="col-6 data"
                @click="handleClick(job)"
                :class="{'isActive':isAcitve(job.job_code)}"
                v-for="(job) in jobList"
                :key="`job-item-${job.job_code}`"
              >
                <div class="row">
                  <div class="col-3 data-title d-flex align-items-center justify-content-center">
                    <p class="m-0 title">第{{job.job_cat}}類</p>
                  </div>
                  <div class="col-9 data-detail">
                    <p class="m-0 mb-1 sub-title">{{job.job_name}}</p>
                    <p class="m-0 address">{{job.lv1_name}}/{{job.lv2_name}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="jobList.length<1"
              class="no-data d-flex justify-content-center align-items-center"
            >
              <h3>查無資料，請確認您輸入之資料是否正確</h3>
            </div>
          </section>
          <section class="action text-right">
            <div class="row">
              <div class="col-12">
                <button class="btn btn-default" @click="$emit('close')">取消</button>
                <button class="btn btn-primary" @click="doSubmit" :disabled="!this.selection">確認</button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getJobs, getJobsByJobName } from "../../service";
import { commonMixin } from '../../mixins/common';

export default {
  name: "JobPickingModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      jobsLoading: false,
      error: false,
      keyword: "",
      list: [],
      selection: null,
      jobList: [],
      jobListBackup:[]
    };
  },
  watch: {
    keyword: "initdate",
    open: "modalOpen"
  },
  methods: {
    //檢查輸入欄位  
    checkKeyword(){
      this.keyword = this.cleanSpecialChar(this.keyword);
      if (this.stringBytes(this.keyword, false, 50) > 50) {
        this.keyword = this.keyword.substring(0, this.stringBytes(this.keyword, true ,50));
      }
    },
    findJob() {
      if(!this.keyword){
        this.$toast.info({ title: "職業關鍵字不可為空" });
        return;
      }

      // 查queryByJobName
      this.jobsLoading = true;
      getJobsByJobName(this.$store.state.userInfo.id, this.keyword).then(res => {
        if (res.header && res.header.status == "200") {
          let lists = res.body.lists;
          lists.sort(function(data1, data2){
            return data1.mi_no - data2.mi_no;
          })
        
          this.jobList = [...lists];
          this.jobListBackup = [...lists];
        } else {
          this.jobList = [];
          this.jobListBackup = [];
        }
        this.jobsLoading = false;
        this.jobList = this.jobList.filter(job => {
          const title = job.job_name;
          const hasKeyword = title.includes(this.keyword);
          if (hasKeyword) {
            return job;
          }
        });
      });

    },
    handleClick(job) {
      this.selection = job;
    },
    isAcitve(job_code) {
      if (!this.selection) return false;
      return this.selection.job_code === job_code;
    },
    doSubmit() {
      this.$emit("submit", this.selection);
    },
    queryJobList() {
      this.jobsLoading = true;
      this.jobList = [];
      getJobs(this.$store.state.userInfo.id).then(res => {
        if (res.body) {
          let lists = res.body.lists;
          lists.sort(function(data1, data2){
            return data1.mi_no - data2.mi_no;
          })
        
          this.jobList = [...lists];
          this.jobListBackup = [...lists];
        } else {
          this.jobList = [];
          this.jobListBackup = [];
        }
        this.jobsLoading = false;
      });
    },
    initdate(){
      this.jobList = this.jobListBackup
    },
    modalOpen() {
      if(this.open){
        this.selection = null;
        this.queryJobList();
      }   
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    }
  }
};
</script>


<style  lang="scss" scoped>
.maintain {
  background: #e7e7e7;
  min-height: 400px;
  border: 1px solid #c2c4c7;
}

.action {
  padding-top: 12px;
}

.data {
  border: 1px solid white;
  background: white;
  border-top: 1px solid #c2c4c7;
  box-shadow: 1px 1px #c2c4c7;
  .row {
	height: 100%;
   }	
  .title,
  .sub-title {
    font-size: 15px;
    font-weight: 600;
    color: #323a45;
  }

  .address {
    font-size: 13px;
    font-weight: normal;
    color: #c2c4c7;
  }
}

.data:nth-of-type(1) {
  border-top: 1px solid white;
}

.data:nth-of-type(2) {
  border-top: 1px solid white;
}

.data:nth-of-type(2n) {
  border-left: 1px solid #c2c4c7;
  border-right: 1px solid white;
}

.data.isActive {
  border: 1px solid #53c480;
  background: #e5f6ec;

  .title,
  .sub-title {
    font-size: 15px;
    font-weight: 600;
    color: #027a39;
  }

  .address {
    font-size: 13px;
    font-weight: normal;
    color: #027a39;
  }

  .data-detail {
    border-left: 1px solid #53c480;
    background: #e5f6ec;
  }
}

.data.isActive:nth-of-type(2n) {
  border: 1px solid #53c480;
  border-left-width: 1;
}

.no-data {
  height: 400px;
}

.data-detail {
  border-left: 1px solid #c2c4c7;
  background: white;
  padding: 10px 10px;
}
</style>